<template>
  <div class="pc_only">
    <h2 class="kojin-title" style="background-color:orange"><slot>タイトル</slot></h2>
  </div>
  
  <span class="sp_only">
      <!-- ユーザー切替え対応 ユーザー名の表示とクリックした時にユーザー切替え画面を表示する -->
      <span class="sp-title" style="color:#FFF;background: #FF8400;">
        <span v-on:click="home" >← <slot>タイトル</slot></span>
          <input type="text" class="form-control form-select" v-if="GlobalData.user_name && family_flg" v-bind:value="GlobalData.user_name" v-on:click="multipleusers_change" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.user_name && family_flg==false" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
        
      </span>
  </span>
  <div class="p-2" style="margin-top:0;background-color:white">
    
    <!-- ユーザー登録後アンケート未回答の場合（実施する場合のみ） -->
     <!-- 各文言はuserdata.jsより -->
    <div v-if="enqete_ok == 0" style="text-align:center">
     {{GlobalData.$enqete_mikaitou}}<br>
      <span v-on:click="move_enqete" style="color:red;cursor: pointer;"><u>{{GlobalData.$enqete_link}}</u></span><br>
      <hr style="width:100%">
    </div>
    <div v-if="midoku_count!=0" class="pc_only" style="color:red;cursor: pointer;" :onclick="move_notification">
      <u>
        未読のお知らせが {{midoku_count}} 件あります。
      </u>
     </div>
    <!-- パンくずリスト -->
    <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>{{ev}}
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
      </ol>
    </nav>
	
    
    <div id="manual_area" >

  <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />マイページのマニュアル</span>
    <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>
    <span class="sp_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png" style="height:35px"  /></span>

  </div>
    
  <br clear="all">
    <!-- ボタン（スマホのみ） -->
    <div class="sp_button_area" style="text-align:center;padding-bottom:10px;
      flex-direction: row;
        justify-content: center;" v-if="code_reader_flg">
      <div v-if="checkin_flg==1">  
        <button class="btn btn-primary mx-aut" 
          style="font-size: 13.5px;width: 200px; height: 40px;margin:15px 5px 10px;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000" 
          v-on:click="codereader()">二次元コード読取</button>
      </div>
    </div>

    <!-- 申込内容一覧 -->
    <template v-if="jizen.length!=0 || jigo.length!=0 || program.length != 0">
      <div style="float: left;display: flex;align-items: center;margin-bottom: 10px;">
        <b style="font-size: 17px;margin-right:10px">申込内容一覧</b>
        <template v-if="ichiran_open"><input type="button" value="一覧を閉じる" v-on:click="ichiran_change(false)" class="ichiran_button"></template>
        <template v-else><input type="button" value="一覧を開く" v-on:click="ichiran_change(true)" class="ichiran_button"></template>
      </div>
      <table border="1" rules="all" id="moushikomi_list" v-if="ichiran_open" >
        <tr>
          <th>種類</th>
          <th>名称</th>
          <th>次回参加日</th>
        </tr>
        <template v-if="jizen.length!=0 && Shakyo_data.jizen_jisshi == 1" >
          <template v-for="(jizen_column,i) in jizen" v-bind:key="i">
            <tr>
              <td>事前</td>
              <td >
                <a href="javascript:void(0);" v-on:click="link_program('jizen',jizen_column.program_id,jizen_column.moshikomi_count)"> {{jizen_column.jizen_name}}</a>
              </td>
              <td>
                  
                <template v-if="jizen_column.jokyo == 1">
                  <!--参加前-->
                  <template v-if="jizen_column.kensyu_date"> 
                    <template v-if="jizen_column.syurui == 3">
                      
                      <!--開催前、または、視聴期間前-->
                      <template v-if="Shichou_kikan(jizen_column.kensyu_date,jizen_column.movie_start_date)">
                        <!-- 動画視聴の場合 -->
                        <template v-if="jizen_column.movie_start_date && jizen_column.kensyu_date">
                            <!--両方とも入力-->
                            {{ DateSetting(jizen_column.movie_start_date) }} ～ {{ DateSetting(jizen_column.kensyu_date) }}
                        </template>
                        <template v-else-if="!jizen_column.movie_start_date && jizen_column.kensyu_date">
                            <!--至のみ入力-->
                            {{ DateSetting(jizen_column.kensyu_date) }} まで
                        </template>
                        <template v-else-if="jizen_column.movie_start_date && !jizen_column.kensyu_date">
                            <!--自のみ入力-->
                            {{ DateSetting(jizen_column.movie_start_date) }} 以降
                        </template>
                        <template v-else>
                          ー
                        </template>
                      </template>
                      <template v-else>
                          ー
                      </template>
                    </template>
                    <template v-else>
                    
                      <template v-if="OverCheck(jizen_column.kensyu_date)">
                        {{ DateSetting(jizen_column.kensyu_date) }} 
                      </template>
                      <template v-else>
                        <!--期間オーバー-->
                        ー
                      </template>
                    </template>
                  </template>
                    
                  <template v-else>
                    <!--日付設定なし-->
                    ー
                  </template>
                </template>
                <template v-else>
                  <!--参加済みまたは視聴済み-->
                  ー
                </template>
              </td>
            </tr>
          </template>
        </template>
        <template v-if="jigo.length!=0 && Shakyo_data.jigo_jisshi == 1">
          <template v-for="(jigo_column,i) in jigo" v-bind:key="i">
            <tr>
              <td>事後</td>
              <td>
                <a href="javascript:void(0);" v-on:click="link_program('jigo',jigo_column.program_id,jigo_column.moshikomi_count)"> {{jigo_column.jigo_name}}</a>
              </td>
              <td>
                <template v-if="jigo_column.jokyo == 1">
                  <!--参加前-->
                  <template  v-if="OverCheck(jigo_column.jigo_kaisai)">
                    <!--開催前-->
                    {{ DateSetting(jigo_column.jigo_kaisai) }}
                  </template>
                  <template v-else>
                    <!--期間オーバー-->
                    ー
                  </template>
                </template>
                <template v-else>
                  <!--参加済み-->
                  ー
                </template>
              </td>
            </tr>
          </template>
        </template>
        <template v-if="program.length!=0">
          <template v-for="(pg,i) in program" v-bind:key="i">
            <tr>
              <td>体験</td>
              <td>
                
                <a href="javascript:void(0);" v-on:click="link_program('taiken',pg.program_id,pg.moshikomi_count)"> 
                {{pg.taiken_no_text}}：{{pg.name}}
                <template v-if="pg.moshikomi_count != 0">
                  （{{ (pg.moshikomi_count+1) }}回目）
                </template>
                </a>
              </td>
              <td>
                <template v-if="pg.next_kaisai_date != null">
                  {{ DateSetting(pg.next_kaisai_date) }}
                </template>
                <template v-else>
                  ー
                </template>
              </td>
            </tr>

          </template>
        </template>
      </table>
      <hr width="100%">
    </template>

    <!-- 事前説明会・体験プログラム概要 -->
    <div v-if="mode=='dsp'"> 
      <template v-if="Shakyo_data.jizen_jisshi == 1">
      <div v-if="jizen.length!=0" style="text-align:left;padding-left:6px;"><b style="font-size: 17px;">事前説明会</b></div>
      <div align="left" v-for="(jizen_column,i) in jizen" v-bind:key="i">

        <!-- 種類が対面・オンライン・特殊の場合 -->
        <table v-if="jizen_column.syurui != '3'" v-bind:id="'jizen'+(jizen_column.program_id)+(jizen_column.moshikomi_count)" border="1" rules="all" style="width:100%;border-collapse:collapse;border:2px solid #06F;background-color:cornsilk">
         <tr>
          <td width="150px"><b>説明会名称</b></td>
          <td class="d-flex">   <!-- bootstarpを使用してボタンを右側に配置  親要素d-flex 子要素(ボタン)にms-autoを設定-->
            <b>{{ jizen_column.jizen_name }}</b>
            <!-- QRコードの表示はPCの場合はボタン押下より２次元コード表示画面 -->
            <!-- ボタンは開催日（kensyu_date）未設定の場合 or 開催日（kensyu_date）当日に表示（どちらも未チェックイン時に限る） -->
            <button v-if="checkin_flg == 1 && checkin_disp_flg==2"
              class="btn btn-primary ms-auto"    
              style="font-size: 13.5px;width: 150px; height: 100%;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000" 
              v-on:click="codeshow('checkjizen',jizen_column.jizen_id,jizen_column.taikenuser_id)">二次元コード表示
            </button>  
          </td>
         </tr>
          <tr>
          <td><b>種類</b></td>
          <td ><b>{{ syurui_list[jizen_column.syurui] }}</b></td>
         </tr>
         <tr>
          <td ><b>開催日</b></td>
          <td >
            <template v-if="jizen_column.kensyu_date">
              {{ DateSetting(jizen_column.kensyu_date) }}
            </template>
            <template v-else>
              ー
            </template>
          </td>
         </tr>
         <tr>
          <td ><b>説明会場所</b></td>
          <td >{{ jizen_column.basyo }}</td>
         </tr>
        <template v-if="jizen_column.syurui == '1' || jizen_column.syurui == '3'">
          <tr>
              <td ><b>住所</b></td>
              <td >
                <span v-if="jizen_column.jusyo == '' || jizen_column.jusyo == null  || jizen_column.jusyo == 'None'">ー</span>
                <u v-else style="color:red;cursor:pointer" v-on:click="googlemap(jizen_column.jusyo)">{{ jizen_column.jusyo }}</u>
              </td>
            </tr>
          </template>
         <tr>
          <td ><b>時間</b></td>
          <td >
             {{ TimeSetting(jizen_column.jizen_jikantai_start) }}&nbsp;～&nbsp;{{ TimeSetting(jizen_column.jizen_jikantai_end) }}
          </td>
         </tr>
            <!-- QRコードの表示は開催日（kensyu_date）未設定の場合 or 開催日（kensyu_date）当日に表示（どちらも未チェックイン時に限る） -->
         <!-- classのsp_onlyは、レイアウトに影響したのでcssを変更してtrタグでもレイアウトに影響しないようにした -->
         <!--
         <tr v-if="checkin_flg == 1"
          class="sp_only_table">  
          <td colspan="2" style="font-size:16px;padding:1pt 6pt;background-color:cornsilk;">
            <b>二次元コード</b>
            <span class="d-flex justify-content-center">
              <QRCodeVue3
                  :value="qr_url + '/checkjizen/' + jizen_column.jizen_id + '/' + jizen_column.taikenuser_id"
                  :width="150"
                  :height="150"
                  :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
                  :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
                  :dotsOptions="{
                    type: 'square',
                    color: '#000000',
                    gradient: {
                      type: 'linear',
                      rotation: 0,
                      colorStops: [
                        { offset: 0, color: '#000000' },
                        { offset: 1, color: '#000000' },
                      ],
                    },
                  }"
                  :backgroundOptions="{ color: '#ffffff' }"
                  :cornersSquareOptions="{ type: 'dot', color: '#000000' }"
                  :cornersDotOptions="{ type: undefined, color: '#000000' }"
                  fileExt="png"
                  :download="false"
                  myclass="my-qur"
                  imgclass="img-qr"
                  downloadButton="my-button"
                  :downloadOptions="{ name: 'vqr', extension: 'png' }"
                />
            </span>
          </td>
         </tr>

            -->

         <template v-if="jizen_column.bikou1 != '' && jizen_column.bikou1 != null && jizen_column.bikou1 != 'None'">
            <tr>
              <td><b>特記事項</b></td>
               <td>
                  <span style="color:red;white-space: pre-wrap;">{{ jizen_column.bikou1 }}</span>
               </td>
          </tr>

         </template>

         <tr style="border-top:2px solid #06F">
          <td style="background-color:orange"><b>参加状況</b></td>
          <td v-if="jizen_column.jokyo == 2" style="background-color:#ADE0EE;">
             【参加済】<br class="sp_only">{{ EuDateTimeSetting(jizen_column.checkin_date) }} 
          </td>
          <td v-else style="background-color:#FFE4E1;" >
            <span v-if="jizen_column.syurui == 2">
              <u  style="color:red;cursor:pointer" v-on:click="online_sanka(jizen_column.url)">オンライン説明会に参加する</u>
            </span>
            <span v-else>未参加</span>
          </td>
         </tr>
         <tr  v-if="jizen_column.syurui == 2">
          <td style="background-color:orange"><b>ミーティングID</b></td>
          <td >
             {{jizen_column.meeting_id}}
          </td>
          
         </tr>
         <tr   v-if="jizen_column.syurui == 2">
          <td style="background-color:orange"><b>パスコード</b></td>
          <td >
             {{jizen_column.passcode}}
          </td>
          
         </tr>
        </table>

        <!-- 種類が動画視聴の場合 -->
        <table v-else border="1"  v-bind:id="'jizen'+(jizen_column.program_id)+(jizen_column.moshikomi_count)"  rules="all" style="width:100%;border-collapse:collapse;border:2px solid #06F;background-color:cornsilk">
         <tr>
          <td width="150px"><b>説明会名称</b></td>
          <td ><b>{{ jizen_column.jizen_name }}</b></td>
         </tr>
          <tr>
          <td><b>種類</b></td>
          <td ><b>動画視聴</b></td>
         </tr>
                    
         <tr>
            <td ><b>視聴期間</b></td>
            <td >
               <template v-if="jizen_column.movie_start_date && jizen_column.kensyu_date">
                  <!--両方とも入力-->
                  {{ DateSetting(jizen_column.movie_start_date) }} ～ {{ DateSetting(jizen_column.kensyu_date) }}
               </template>
               <template v-else-if="!jizen_column.movie_start_date && jizen_column.kensyu_date">
                  <!--至のみ入力-->
                  {{ DateSetting(jizen_column.kensyu_date) }} まで
               </template>
               <template v-else-if="jizen_column.movie_start_date && !jizen_column.kensyu_date">
                  <!--自のみ入力-->
                  {{ DateSetting(jizen_column.movie_start_date) }} 以降
               </template>
               <template v-else>
                ー
               </template>
            </td>
        </tr>
         <template  v-if="jizen_column.bikou1 != '' && jizen_column.bikou1 != null && jizen_column.bikou1 != 'None'">
            <tr>
              <td><b>特記事項</b></td>
               <td>
                  <span style="color:red;white-space: pre-wrap;">{{ jizen_column.bikou1 }}</span>
               </td>
          </tr>

         </template>
         <tr style="border-top:2px solid #06F">
          <td style="background-color:orange"><b>状況</b></td>
          <td v-if="jizen_column.jokyo == 2" style="background-color:#ADE0EE;">
             【視聴済】<br class="sp_only">{{ EuDateTimeSetting(jizen_column.checkin_date) }} <br>
              <template v-if="Shichou_kikan(jizen_column.kensyu_date,jizen_column.movie_start_date)">
                <u style="color:red;cursor:pointer" v-on:click="movie_shichou(jizen_column.url,jizen_column.jizen_id,2)">動画を視聴する</u>
              </template>
              <template v-else>
                <b>動画の視聴期間外です。</b>
              </template>
          </td>
          <td v-else style="background-color:#FFE4E1;" >
            <template v-if="Shichou_kikan(jizen_column.kensyu_date,jizen_column.movie_start_date)">
              <u style="color:red;cursor:pointer" v-on:click="movie_shichou(jizen_column.url,jizen_column.jizen_id,1)">動画を視聴する</u>
            </template>
            <template v-else>
              <b>動画の視聴期間外です。</b>
            </template>
          </td>
         </tr>
        </table>

        <table v-if="jizen_check(jizen_column.jizen_no,jizen_column.jokyo)" border="1" rules="all" style="width:100%;border-collapse:collapse;border:2px solid #06F;border-top:0">
         <tr >
          <td v-on:click="jizen_cancel_check(jizen_column.jizen_id)" style="text-align: center;background-color: red;color: white;cursor: pointer;">
            キャンセルする
          </td>
         </tr>
        </table>
        <div style="margin-bottom:12px;"></div>
      </div>
      </template>

      <template v-if="Shakyo_data.jigo_jisshi == 1">
      <div v-if="jigo.length!=0" style="text-align:left;padding-left:6px;"><b style="font-size: 17px;">事後集会</b></div>
        <div align="left" v-for="(jigo_column,i) in jigo" v-bind:key="i">

        <table border="1" rules="all"  v-bind:id="'jigo'+(jigo_column.program_id)+(jigo_column.moshikomi_count)"  style="width:100%;border-collapse:collapse;border:2px solid #06F;background-color:cornsilk">
         <tr>
          <td width="150px"><b>集会名称</b></td>
          <td class="d-flex">   <!-- bootstarpを使用してボタンを右側に配置  親要素d-flex 子要素(ボタン)にms-autoを設定-->
            <b>{{ jigo_column.jigo_name }}</b>
            <button v-if="checkin_flg==1 && checkin_disp_flg==2" class="btn btn-primary ms-auto" 
              style="font-size: 13.5px;width: 150px; height: 100%;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000" 
              v-on:click="codeshow('checkjigo',jigo_column.jigo_id,jigo_column.taikenuser_id)">二次元コード表示
            </button>
          </td>
         </tr>
          <tr>
          <td><b>種類</b></td>
          <td ><b>{{ syurui_list[jigo_column.jigo_syurui] }}</b></td>
         </tr>
         <tr>
          <td ><b>開催日</b></td>
          <td >{{ DateSetting(jigo_column.jigo_kaisai) }}</td>
         </tr>
         <tr>
          <td ><b>開催場所</b></td>
          <td >{{ jigo_column.jigo_basyo }}</td>
         </tr>
         <template v-if="jigo_column.jigo_syurui == 1" >
         <tr>
          <td ><b>住所</b></td>
          <td >
            <span v-if="jigo_column.jigo_jusyo == '' || jigo_column.jigo_jusyo == null  || jigo_column.jigo_jusyo == 'None'">ー</span>
            <u v-else style="color:red;cursor:pointer" v-on:click="googlemap(jigo_column.jigo_jusyo)">{{ jigo_column.jigo_jusyo }}</u>
          </td>
         </tr>
        </template>
         <tr>
          <td ><b>時間</b></td>
          <td >
             {{ TimeSetting(jigo_column.jigo_jikantai_start) }}&nbsp;～&nbsp;{{ TimeSetting(jigo_column.jigo_jikantai_end) }}
          </td>
         </tr>

         <template  v-if="jigo_column.jigo_bikou1 != '' && jigo_column.jigo_bikou1 != null && jigo_column.jigo_bikou1 != 'None'">
            <tr>
              <td><b>特記事項</b></td>
               <td>
                  <span style="color:red;white-space: pre-wrap;">{{ jigo_column.jigo_bikou1 }}</span>
               </td>
          </tr>
           <!-- classのsp_onlyは、レイアウトに影響したのでcssを変更してtrタグでもレイアウトに影響しないようにした -->
          <!--
          <tr v-if="checkin_flg == 1" class="sp_only_table">
            <td colspan="2" style="font-size:16px;padding:1pt 6pt;background-color:cornsilk;">
              <b>二次元コード</b><br>
              <span class="d-flex justify-content-center">
                <QRCodeVue3
                    :value="qr_url + '/checkjigo/' + jigo_column.jigo_id + '/' + jigo_column.taikenuser_id"
                    :width="150"
                    :height="150"
                    :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
                    :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
                    :dotsOptions="{
                      type: 'square',
                      color: '#000000',
                      gradient: {
                        type: 'linear',
                        rotation: 0,
                        colorStops: [
                          { offset: 0, color: '#000000' },
                          { offset: 1, color: '#000000' },
                        ],
                      },
                    }"
                    :backgroundOptions="{ color: '#ffffff' }"
                    :cornersSquareOptions="{ type: 'dot', color: '#000000' }"
                    :cornersDotOptions="{ type: undefined, color: '#000000' }"
                    fileExt="png"
                    :download="false"
                    myclass="my-qur"
                    imgclass="img-qr"
                    downloadButton="my-button"
                    :downloadOptions="{ name: 'vqr', extension: 'png' }"
                  />
              </span>
            </td>
          </tr>
          -->
         </template>
         <tr style="border-top:2px solid #06F">
          <td style="background-color:orange"><b>参加状況</b></td>
          <td v-if="jigo_column.jokyo == 2" style="background-color:#ADE0EE;">
             【参加済】<br class="sp_only">{{ EuDateTimeSetting(jigo_column.checkin_date) }} 
          </td>
          <td v-else style="background-color:#FFE4E1;" >
            <span v-if="jigo_column.jigo_syurui == 2">
              {{jigo_column.syurui}}
              <u  style="color:red;cursor:pointer" v-on:click="online_sanka(jigo_column.jigo_url)">オンライン集会に参加する</u>
            </span>
            <span v-else>未参加</span>
          </td>
         </tr>
         <tr  v-if="jigo_column.jigo_syurui == 2">
          <td style="background-color:orange"><b>ミーティングID</b></td>
          <td >
            <span v-if="jigo_column.jigo_meeting_id == '' || jigo_column.jigo_meeting_id == null  || jigo_column.jigo_meeting_id == 'None'">ー</span>
            <span v-else>{{jigo_column.jigo_meeting_id}}</span>
             
          </td>
          
         </tr>
         <tr v-if="jigo_column.jigo_syurui == 2">
          <td style="background-color:orange"><b>パスコード</b></td>
          <td >
            <span v-if="jigo_column.jigo_passcode == '' || jigo_column.jigo_passcode == null  || jigo_column.jigo_passcode == 'None'">ー</span>
            <span v-else>{{jigo_column.jigo_passcode}}</span>
          </td>
          
         </tr>
        </table>

        <table v-if="jigo_check(jigo_column.jigo_no,jigo_column.jokyo)" border="1" rules="all" style="width:100%;border-collapse:collapse;border:2px solid #06F;border-top:0">
         <tr >
          <td v-on:click="jigo_cancel_check(jigo_column.jigo_id)" style="text-align: center;background-color: red;color: white;cursor: pointer;">
            キャンセルする
          </td>
         </tr>
        </table>
        <div style="margin-bottom:12px;"></div>
      </div>
      </template>
    <div style="text-align:left;padding-left:6px;margin-top:20px"><b style="font-size: 17px;">体験プログラム</b></div>

    <div align="left" v-for="(pg,i) in program" v-bind:key="pg.id">
    <div class="taiken_table" style="padding:4px;margin-bottom:12px;">
    <table border="1" rules="all" v-bind:id="'taiken'+(pg.program_id)+(pg.moshikomi_count)"  s style="width:100%;border-collapse:collapse;">
      <tr v-on:click="myshosai(i)">
        <td  style="padding:2pt 6pt;background-color:white;border-right: 0;width:50%">
          
          {{ pg.bunrui1 }}
          <span v-if="shosai_disp[1] == 1">
            <br>
            {{pg.bunrui2 }}
          </span>
        </td>
        <td style="background-color:white;border-left: 0;text-align:right">
          
            <span v-if="pg.qr_read_flg && checkin_flg==1" class=" ms-auto align-middle" style=" height:100%;padding:0px;">
              <template v-if="pg.sanka != 4">
                <button class="btn btn-primary" 
                  style="font-size: 13.5px;width: 150px;background-color: #F5F5F5;color:#000;border:1px solid #000" 
                  v-on:click.stop="codeshow('checktaiken',pg.program_id,pg.taikenuser_id)">二次元コード表示
                </button>
              </template>
            </span>
        </td>
      </tr>

      <!--
        <div style="font-size:16px">{{ pg.naiyou}}</div>-->
      <tr v-on:click="myshosai(i)">
        <td colspan="2" style="padding:2pt 6pt;background-color:royalblue;color:white;">
          <div class="d-flex" style="font-size:20px">   <!-- bootstarpを使用してボタンを右側に配置  親要素d-flex 子要素(ボタン)にms-autoを設定-->
            <u>{{ pg.taiken_no_text }}：{{pg.name }}
            <template v-if="pg.moshikomi_count != 0">
              （{{ (pg.moshikomi_count+1) }}回目）
            </template>
            </u>
            
          </div>
        </td>
      </tr>
      
      <tr v-if="shosai_disp[4] == 1">
        <td colspan="2" style="padding:2pt 6pt;background-color:cornsilk;cursor:pointer" v-on:click="myshosai(i)">
          <b style="cursor:pointer">施設住所：</b>{{pg.k_jusyo}}
        </td>
      </tr>
      <tr v-on:click="myshosai(i)" v-if="shosai_disp[3] == 1">
        <td colspan="2" style="font-size:16px;padding:1pt 6pt;background-color:cornsilk;" border="1">
          <b>活動内容：</b>{{ pg.naiyou}}
        </td>
      </tr>
      <tr style="background-color:orange;" v-on:click="myshosai(i)">
        <td width="100px">
          <b v-if="pg.shubetsu == 1">参加状況</b>
          <b v-else-if="pg.shubetsu == 2">提出状況</b>
        </td>

        <td v-if="pg.sanka==4" style="padding:3pt;background-color:#f9a9a0;">
          キャンセル待ち
        </td>
        <td v-if="pg.sanka==0" style="padding:3pt;background-color:#FFE4E1;">
          <span v-if="pg.shubetsu == 1">
            未参加
          </span>
          <span v-else-if="pg.shubetsu == 2">
            未提出
          </span>
        </td>
        <td v-if="pg.sanka==1 && !kesseki_f" style="padding:3pt;background-color:#ADE0EE">
          
          <span v-if="pg.shubetsu == 1">
          【参加済】<span style="color:red;padding-right: 10px;">{{ pg.checkin_cnt }}日目[最終]</span><br class="sp_only"><template v-if="pg.checkin_date">{{ EuDateTimeSetting(pg.checkin_date) }} </template>
          </span>
          <span v-else-if="pg.shubetsu == 2">
          【提出済】<br class="sp_only">{{ EuDateTimeSetting(pg.checkin_date) }} 
          </span>
        </td>
        <td v-if="pg.sanka==2" style="padding:3pt;background-color:ivory;">
          【参加中】<span style="color:red;padding-right: 10px;">{{ pg.checkin_cnt }}日目</span><br class="sp_only">{{ EuDateTimeSetting(pg.checkin_date) }} 
        </td>
        <td v-if="pg.sanka==3 || kesseki_f" style="padding:3pt;background-color:ivory;">
          【欠席】※報告書の提出・証明書の発行はできません。
        </td>
      </tr>
      <tr style="background-color:orange;">
        <td width="100px" v-on:click="myshosai(i)">
          <b>報告書</b>

        </td>
        <td v-if="pg.houkoku==0 && (pg.sanka!=1 || kesseki_f)" style="padding:3pt;background-color:#FFE4E1;" v-on:click="myshosai(i)">
          
          <div v-if="Shakyo_data.houkoku_shubetsu == 2 || pg.google_form == 0">ー</div>
          <div v-else>未提出</div>
        </td>
        <td v-if="pg.houkoku==0 && pg.sanka==1 && !kesseki_f" style="padding:3pt;background-color:ivory;">

          <div v-if="Shakyo_data.houkoku_shubetsu == 2 || pg.google_form == 0">報告書の提出が必要です（提出方法は社協にご確認ください）。</div>
          <div v-else v-on:click="quest(i)"><u style="color:#cc0000">活動報告書を提出してください。</u></div>
        </td>
        <td v-if="pg.houkoku==1" style="padding:3pt;background-color:#ADE0EE;" v-on:click="myshosai(i)">
          【提出済】<br class="sp_only">{{ EuDateTimeSetting(pg.houkoku_date) }}
        </td>
      </tr>
      <tr style="background-color:orange" v-if="pg.shomeisho != 0 && Shakyo_data.shomeisho_shubetsu == 1">
        <td width="100px" v-on:click="myshosai(i)">
          <b>参加証明書</b>
        </td>
        <!-- 日数を満たしていない -->
        <td v-if="!nissu_ok" style="padding:3pt;background-color:#FFE4E1;cursor:default">参加証明書の発行には、全体で<u style="color:red">{{Shakyo_data.taiken_nissu}}日以上</u>の参加が必要です。</td>
        
        <!-- 参加完了 or 報告書の提出が終わっていない -->
        <td v-else-if="pg.syomei==0 && pg.houkoku!=1" style="padding:3pt;background-color:#FFE4E1;" v-on:click="myshosai(i)">未取得</td>
        
        <!-- 報告書の提出完了・事後集会へ未参加 -->
        <td v-else-if="((pg.syomei==0 || pg.syomei==1) && pg.houkoku==1) && jigo_ok(pg) == false" style="padding:3pt;background-color:#FFE4E1;">
           参加証明書の発行には、事後集会への参加が必要です。
        </td>

        <!-- 報告書の提出完了・社協が未確認 -->
        <td v-else-if="Shakyo_data.houkoku_kainyu == 1 && (pg.houkoku_check == '' || pg.houkoku_check == null || pg.houkoku_check == 'None')" style="padding:3pt;background-color:#FFE4E1;">
          社協が報告書を確認するまで、発行できません。
        </td>

        <!-- 状況が欠席(証明書発行可)の場合は、証明書は発行できません。 -->
        <td v-else-if="kesseki_f" style="padding:3pt;background-color:#FFE4E1;">
          【欠席】※参加証明書の発行はできません。
        </td>

        <!-- ダウンロード可能・一回もダウンロードしていない -->
        <td v-else-if="pg.syomei==0 && pg.houkoku==1" style="padding:3pt;background-color:ivory;">
           <div v-on:click="cert(i)"><u style="color:#cc0000">参加証明書を取得可能です。</u> 0 / {{shomaisho_count}}回</div>
        </td>

        <!-- ダウンロード可能・一回以上ダウンロードしている -->
        <td v-else-if="pg.syomei == 1 && pg.syomei_count != shomaisho_count" style="padding:3pt;background-color:ivory;">
            <div><u style="color:#cc0000;cursor:pointer" v-on:click="cert(i)">参加証明書を取得可能です。</u></div>
            【発行日】<br class="sp_only">{{ EuDateTimeSetting(pg.syomei_date) }}<br>
            【発行数】{{pg.syomei_count}} / {{shomaisho_count}}回

        </td>

        <!-- ダウンロード不可 -->
        <td v-else-if="pg.syomei==1 && pg.syomei_count == shomaisho_count" style="padding:3pt;background-color:#ADE0EE;" v-on:click="myshosai(i)">
          【発行日】<br class="sp_only">{{ EuDateTimeSetting(pg.syomei_date) }}<br>
          【発行数】{{pg.syomei_count}} / {{shomaisho_count}}回
        </td>
      </tr>
  
    </table>
  </div>
    </div>
    
    <h3 v-if="program.length==0">まだ参加予定のプログラムはありません。</h3>
    </div>
    <div v-if="mode=='quest'">
      <h3 style="text-align:left">アンケート＆報告書の画面へ移動します。</h3><br/>
      <div style="text-align:center;padding:6px;float:left">
        <a v-on:click="go_quest" class="btn btn-primary">アンケート＆感想文を書く</a>
      </div>
      <div style="text-align:center;padding:6px;float:left">
        <a v-on:click="mypage" class="btn btn-primary">戻る</a>
      </div>
    </div>
    <div v-if="mode=='cert'">
      <h3 style="text-align:left">参加証明書をダウンロードします。</h3><br/>
      <div style="text-align:center;padding:6px;float:left">
        <a v-on:click="go_cert" class="btn btn-primary">ダウンロード</a>
      </div>
      <div style="text-align:center;padding:6px;float:left">
        <a v-on:click="mypage" class="btn btn-primary">戻る</a>
      </div>
    </div>
  </div>
    
    <div class="sp_button_area" style="text-align:right;padding-bottom:10px;
      font-size:1.2rem;
      margin-right:10px;
      flex-direction: row;">
      <span style="cursor: pointer;"
       v-on:click="setting()"><u>設定</u></span>
     </div>
      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>


      
</template>

<script setup>
/* eslint-disable */ 
import { useRouter,useRoute } from 'vue-router'
import { GlobalData, DateSetting,TimeSetting,DateTimeSetting,EuDateTimeSetting,ShimekiriSetting } from '../js/userdata.js'
import AWS from 'aws-sdk';
import { ref, computed } from 'vue';
import axios from 'axios'
import QRCodeVue3 from "qrcode-vue3";

/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

//const fileInput = ref(null);
const router = useRouter()
const route = useRoute()
const prop = defineProps(['param'])
let program = ref(prop.param.program)
let jizen = prop.param.jizen
let jigo = prop.param.jigo
let jisseki_buf = prop.param.jisseki_buf

// 申込内容一覧を開く・閉じるフラグ
let ichiran_open = ref(true)
let ichiran_change = function(flg){
  ichiran_open.value = flg
}

// 2次元コードのURLの共通部分を設定する
let qr_url = ref(location.protocol + "//" + location.host + "/" + GlobalData.shakyo_code + "/Taiken")

// 今日の日付を取得   YYYYMMDD のフォーマットにする  日付のみの大小比較のため 開催日が過去のものの2次元コードの表示は無しにする
let today = ref(new Date(new Date().toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" })).toISOString().slice(0, 10).replace(/-/g, ''))

// 二次元コードの表示・非表示（申込0の時は非表示にする）
let code_reader_flg = ref(false)
if(program.value.length != 0){
  code_reader_flg.value = true
}
if(jizen.length != 0){
  code_reader_flg.value = true
}
if(jigo.length != 0){
  code_reader_flg.value = true
}

let family_flg = ref(false)  // 家族フラグ(家族の登録が出来る)が設定されている時は、右メニューのボタンが表示される

let family_flg_get_error = 0
const family_flg_get = () => {
    let res = null
    axios.post(GlobalData.$API_URL+"TaikenAccountUser_read", {taikenuser_id:GlobalData.user_id})
    .then(response => {
        
        if(response.data.accountuser){
            res = response.data.accountuser
            family_flg.value = res['family']

        } else {
            family_flg.value = false
        }
    })
    .catch(error => {
        if(family_flg_get_error == 6){
            alert(error + GlobalData.$axios_error)
        }else{
            family_flg_get_error++
            setTimeout(function(){family_flg_get()},"1000")
        }
        
    })
}

family_flg_get()

let cancel_jizen_id = 0 // キャンセル対象の事前説明会ID
let cancel_jigo_id = 0 // キャンセル対象の事後集会ID

const midoku_count = ref(prop.param.midoku_count)
const cityname = prop.param.cityname

// アンケート回答済みかどうか（0：未回答、1：回答済み、2：回答の必要なし）
const enqete_ok = ref(GlobalData.enqete_flg)

//証明書発行回数
let shomaisho_count = ref(3)

// 全て欠席（証明書発行可）を判定するためのフラグ
let work_f = true

for(let i=0;i<jisseki_buf.length;i++){
    if(jisseki_buf[i].program_kbn == 1){
      if(jisseki_buf[i].jokyo != '3' && jisseki_buf[i].jokyo != '9'){
          work_f = false
      }
    }
}

// 全て「欠席（証明書発行可）」の場合は、報告書・証明書の発行はできない。
let kesseki_f = ref(work_f)

// チェックイン機能の利用フラグ
let checkin_flg = ref(2)

// 事業者二次元コード表示フラグ
let checkin_disp_flg = ref(1)

// 表示フラグ
// 分類1（固定）
// 分類2
// プログラム名（固定）
// 活動内容
// 施設住所
// 活動日数
// 受入先からのコメント
// 添付資料
// その他（特記事項）
// 参加費 ---- ここから下は施設・地域のみ
// 検温等
// マスク着用
// 昼食
// 持ち物
// 制作・寄付活動条件 ---- ここから下は制作・寄付のみ
// 届け先
let shosai_disp = ref([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0])

// 表示設定と証明書発行回数を取得
axios.post(GlobalData.$API_URL+"Shakyo_read", 
        {shakyo:route.params.shakyo}
    ).then(response => {
            shosai_disp.value = response["data"].program_shosai_disp.split(',')
            shomaisho_count.value = response["data"].shomeisho_count
            checkin_flg.value = response["data"].checkin_flg
            checkin_disp_flg.value = response["data"].checkin_disp_flg
    })
    .catch(error => {
        
})

// 社協が設けた体験義務日数を満たしているか
let nissu_ok = ref(false)

// このユーザーがチェックインした体験プログラムの数
const taiken_checkin_count = prop.param.taiken_checkin_count

// 所属する社協のデータ
const Shakyo_data = prop.param.Shakyo_data
// 参加日数（チェックイン済の数）と義務日数を比較
if(taiken_checkin_count >= Shakyo_data.taiken_nissu){
  nissu_ok.value = true
}else if(Shakyo_data.taiken_nissu == 1){
  nissu_ok.value = true
}


const emit = defineEmits(['call'])
emit('call', { cmd:'page_scroll'})
const mode = ref("dsp")

// 曜日配列
const youbi_list = ["日","月","火","水","木","金","土"]
// 事前説明会の種類配列
const syurui_list = ["（未設定）","対面","オンライン","動画視聴","特殊（対面）","特殊（オンライン）"]

// キャンセル対象の体験プログラムID
//let cancel_taiken_id = 0;

// 申込済みの事前説明会が申込済みのプログラムに紐づいているかどうか
const jizen_check = (jizen_no,jokyo) =>{
  let return_flg = true // false = キャンセル不可

  if(jokyo == '2'){
    // 説明会参加済の場合はキャンセル不可
    return_flg = false
  }else{
    // プログラムを全て確認
    let taiken = program.value
    for (let t = 0;t<taiken.length;t++){
      
      if(taiken[t]["jizenkensyu_no"]){
        // プログラムに格納された説明会No.を抽出
        let kensyu_array = Array.from(new Set(taiken[t]["jizenkensyu_no"].split(",")))

        // 説明会No.を抽出
        for(let k = 0;k<kensyu_array.length;k++){
            // 紐づいた説明会の実績が存在していたらキャンセル不可
            if(kensyu_array[k] == jizen_no){
              return_flg = false
            }
        }
      }
    }
  }
  return return_flg
}

// 申込済みの事後集会が申込済みのプログラムに紐づいているかどうか
const jigo_check = (jigo_no,jokyo) =>{

  let return_flg = true // false = キャンセル不可

  if(jokyo == '2'){
    // 集会参加済の場合はキャンセル不可
    return_flg = false
  }else{
    // プログラムを全て確認
    let taiken = program.value

    for (let t = 0;t<taiken.length;t++){
      if(taiken[t]["jigosyukai_no"]){
      // プログラムに格納された集会No.を抽出
        let syukai_array = Array.from(new Set(taiken[t]["jigosyukai_no"].split(",")))

        // 説明会No.を抽出
        for(let s = 0;s<syukai_array.length;s++){
            // 紐づいた説明会の実績が存在していたらキャンセル不可
            if(syukai_array[s] == jigo_no){
              return_flg = false
            }
        }
      }
    }
  }
  return return_flg
}

// 事後集会参加確認
const jigo_ok = (pg) => {
  // プログラムの事後集会No.
  let jigo_no = pg.jigosyukai_no

  // 事後集会No.を格納する配列
  let jigo_no_list = [];


  // 体験プログラムの割付事後集会No.を取り出す
  if(jigo_no != "" && jigo_no != null && jigo.length != 0){
    jigo_no_list = jigo_no.split(',')

    // 事後集会に参加しているかどうか
    let ok_flg = 0;
    for(let i = 0;i < jigo.length;i++){
      // プログラムに紐づいたNo.があればその参加状況をチェック
      for(let t = 0;t<jigo_no_list.length;t++){
        if(jigo_no_list[t] == jigo[i]["jigo_no"]){

          // 参加が任意なら状況に関わらずOK
          if(jigo[i]["syomei_flg"] == 1){
            ok_flg = 1
          }else{
            // 未参加・キャンセルではない場合はOK
            if(jigo[i]["jokyo"] != 1 && jigo[i]["jokyo"] != 9) ok_flg = 1
          }
        }
      }
    }

    if(ok_flg == 1){
      return true
    }else{
      return false
    }
  }else{
    // ない場合はtrue
    return true
  }
}

// 事前説明会をキャンセルするか確認
let jizen_cancel_check = function(jizen_id){
  cancel_jizen_id = jizen_id

    message.value = "この事前説明会をキャンセルしますか？";
    message_cat.value = 1;
    message_flag.value = true;
    message_method.value = "jizen_cancel";
    contentMessage.value = MessageModal 
}


// 事後集会をキャンセルするか確認
let jigo_cancel_check = function(jigo_id){
  cancel_jigo_id  = jigo_id
    message.value = "この事後集会をキャンセルしますか？";
    message_cat.value = 1;
    message_flag.value = true;
    message_method.value = "jigo_cancel";
    contentMessage.value = MessageModal 
}


// 事前説明会（kbn=2）・事後集会（kbn=3）をキャンセルする
let JJ_cancel_error = 0
let Jizen_Jigo_cancel = function(kbn){

  let send_array = {
    user_id: GlobalData.user_id,
    jokyo:9,
    program_kbn:kbn,
    update_user:GlobalData.$User_email//更新者（＝ログインユーザーのメールアドレス）
  }
  if(kbn == 2){
    send_array.program_id = cancel_jizen_id
    
  }else if(kbn == 3){
    send_array.program_id = cancel_jigo_id
  }

  axios.post(GlobalData.$API_URL + "Jisseki_Programupdate",send_array,GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
  .then(response => {
    if(response.data["status"] == 1){
      message.value = "エラーが発生しました。" + response.data["message"];
        
    }else{
      rireki_add(send_array.program_id,kbn,0)
      message.value = "キャンセルしました。";
    }
      message_cat.value = 1;
      message_flag.value = true;
      message_method.value = "mypage_reload";
      contentMessage.value = MessageModal
  })
  .catch(error => { 
      if(JJ_cancel_error == 6){
          message.value = error + GlobalData.$axios_error;
          message_cat.value = 0;
          message_flag.value = true;
          message_method.value = "update_error";
          contentMessage.value = MessageModal
      }else{
          JJ_cancel_error++
          setTimeout(function(){
            Jizen_Jigo_cancel(kbn,moshikomi_count)
          },"1000")
      } 
  })
}

  // 履歴登録
  let rireki_add_error = 0
  let rireki_add = function(program_id,program_kbn,moshikomi_count){
    const today = new Date()
    let set_date = new Date(today);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    //rireki_kanri_add(set_date,2,GlobalData.user_id,1,program_id,0)
    let send_data = {shakyo_name:route.params.shakyo,
        choson_code:Shakyo_data.choson_code,
        taikenuser_id:GlobalData.user_id,
        program_kbn:program_kbn,
        program_id:program_id,
        kubun:2,
        moshikomi_count:moshikomi_count,
        toroku_date:set_date,
        update_user:GlobalData.$User_email}

        // APIへ値を送信する
        axios.post(GlobalData.$API_URL+"Rireki_add",
        send_data,
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {

            if(response.data["status"] == 1){

                message.value = GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "rireki_add_error";
                contentMessage.value = MessageModal
            }
            
        })
        .catch(error => {
          if(rireki_add_error == 6){
              message.value = error + GlobalData.$axios_error;
              message_cat.value = 0;
              message_flag.value = true;
              message_method.value = "rireki_add_error";
              contentMessage.value = MessageModal
          }else{
              rireki_add_error++
              setTimeout(function(){
                rireki_add(program_id,program_kbn,moshikomi_count)
              },"1000")
          }
        })
}

//------------------- 体験プログラム一覧表示へ
const home = () => { router.replace("/"+cityname+"/Taiken") }

//------------------- Googlemap（外部リンク）へ
const googlemap = (set_jusho) => { window.open("http://local.google.co.jp/maps?q="+set_jusho,"_blank") }

//------------------- ZOOM等のオンライン参加（外部リンク）へ
const online_sanka = (url)  => { window.open(url,"_blank") }

//------------------- 動画視聴（外部リンク）へ
let movie_error = 0
const movie_shichou = (url,jizen_id,jokyo)  => { 
  window.open(url,"_blank") 
  
  // 視聴済みの場合はここで終了
  if(jokyo == 2){
    return
  }
  
  let send_array = {
    user_id: GlobalData.user_id,
    program_id:jizen_id,
    program_kbn:2,
    jokyo:2,
    update_user:GlobalData.$User_email //更新者（＝ログインユーザーのメールアドレス）
  }
  axios.post(GlobalData.$API_URL+"Jisseki_CheckIn-Out", 
    send_array,
   GlobalData.$ID_Token)
    .then(response => {
      router.go("/"+cityname+"/Taiken/mypage" )
    })
    .catch(error => {
        
          if(movie_error == 6){
              message.value = error + GlobalData.$axios_error;
              message_cat.value = 0;
              message_flag.value = true;
              message_method.value = "movie_error";
              contentMessage.value = MessageModal
          }else{
              movie_error++
              setTimeout(function(){
                movie_shichou(url,jizen_id,jokyo) 
              },"1000")
          }
    })
}

const myshosai = (i) => {
    emit('call',{ cmd:'myshosai', program:program.value[i]})
}

const mypage = () => {
    mode.value = 'dsp'
}

const sanka = (i) => { router.push('/'+cityname+'/Taiken/Checkin/'+(program.value[i].program_id)) }


let quest_no = 0
const quest = (i) => {
    quest_no = i
//    mode.value = "quest"
    message.value = "活動報告を行いますか？";
    message_cat.value = 1;
    message_flag.value = true;
    message_method.value = "go_quest";
    contentMessage.value = MessageModal 
}

// 活動報告ページへ移動
const go_quest = () => {
  // ページへ移動する際はURLを変えずに親コンポーネントへ命令を送るだけにする（回答後の再入場防止のため）
  emit('call', { cmd:'report', 
                program_id:program.value[quest_no].program_id,
                form_no:program.value[quest_no].google_form,
                moshikomi_count:program.value[quest_no].moshikomi_count})
}

let cert_no = 0
const cert = (i) => {
    cert_no = i
//    mode.value = "cert"

    message.value = "参加証明書をダウンロードしますか？";
    message_cat.value = 1;
    message_flag.value = true;
    message_method.value = "go_cert";
    contentMessage.value = MessageModal 
}

const go_cert = () => {
    let url = "/"+route.params.shakyo+"/Taiken/Shomei/" + GlobalData.user_id + "/" + program.value[cert_no].taiken_id+"/"+program.value[cert_no].moshikomi_count
    window.open(url)
    mode.value = "dsp"
    emit('call', { cmd:'cert',
        program_id:program.value[cert_no].program_id,
        syomei_count:program.value[cert_no].syomei_count,
        moshikomi_count:program.value[cert_no].moshikomi_count})
}


// 体験アカウントを削除する
let Delete_set = function() {
  emit('call',{cmd:'user_delete'});
}

  // 指定したプログラムへ移動する
  let link_program = function(cat,program_id,count){
    let id = cat + program_id + count
    Page_id_focus(id)
  }

  // 指定のタグにフォーカスさせる
  let Page_id_focus = function(id){
    console.log(id)
    const elements = document.getElementById(id)
    elements.focus({preventScroll:false})
    elements.scrollIntoView({ behavior: 'instant', block: 'start' });

  }

// メッセージを表示するウィンドウでOKを押された時
let OK_message = function(){ 
    Close_message();//メッセージを表示するウィンドウを閉じる

    // プログラムをキャンセルする（廃止）
    if(message_method.value == "cancel_kettei"){
      //Cancel_Jizen_check()
      //emit('call',{ cmd:'cancel', program_id:cancel_taiken_id, update_user:GlobalData.$User_email })
    }else if(message_method.value =="mypage_reload"){
      // キャンセル後の処理
      router.go("/"+cityname+"/Taiken/mypage" )
      
    }else if(message_method.value == "go_quest"){
      //活動報告を行いますか？
      go_quest()
    }else if(message_method.value == "go_cert"){
      // 参加証明書を発行しますか？
      go_cert()
    }else if(message_method.value == "delete"){
      // アカウントを削除しますか？
      Delete_set()
    }else if(message_method.value == "jizen_cancel"){
      // 事前説明会をキャンセルしますか？ → 事前説明会をキャンセルする処理へ
      Jizen_Jigo_cancel(2)
    }else if(message_method.value == "jigo_cancel"){
      // 事後集会をキャンセルしますか？ → 事後集会をキャンセルする処理へ
      Jizen_Jigo_cancel(3)
    }else if(message_method.value =="mypage_reload"){
      // キャンセル後はページを読み直す
      location.reload()
    }

}

// メッセージを表示するウィンドウを閉じる
let Close_message = function(){
    message_flag.value = false;
    contentMessage.value = null
}

// お知らせへ移動
let move_notification = function(){
  
  router.push('/'+cityname+'/Taiken/notification') 
}

// ユーザー登録後アンケートへ移動
let move_enqete = function(){
  router.push('/'+cityname+'/Taiken/enqete/1') 

}

// 二次元コード（スマホのみ）移動
const codereader = function() {
  emit('call', { cmd:'Readcode'})
}
// 設定画面（スマホのみ）移動
const setting = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    router.push("/"+cityname+"/Taiken/setting" )
}


// 視聴期間の確認（動画視聴の場合のみ）
let Shichou_kikan = function(shicho_day,start_day){
  
    let today = new Date()
    console.log(today)
    if(shicho_day && start_day){
      // 期間（自・至）両方入力
      let shicho_date = Shichou_kikan_Setting(shicho_day)
      let start_date = Shichou_kikan_Setting(start_day)
      console.log(shicho_date +"/"+ start_date)
      // 今日の日付が視聴期間内なら動画視聴可能
      if (shicho_date >= today && start_date <= today) {
        return true
      } else {
        return false
      }
    }else if(!shicho_day && start_day){

      // 期間（自）のみ入力
      let start_date = Shichou_kikan_Setting(start_day)
      console.log( start_date)
      // 今日の日付が視聴期間内なら動画視聴可能
      if (start_date <= today) {
        return true
      } else {
        return false
      }
    }else if(shicho_day && !start_day){
      // 期間（至）のみ入力
      let shicho_date = Shichou_kikan_Setting(shicho_day)
      console.log(shicho_date)
      
      // 今日の日付が視聴期間内なら動画視聴可能
      if (shicho_date >= today) {
        return true
      } else {
        return false
      }
    }else{
      // 視聴期間（自・至）が未入力なら動画視聴可能
      return true
    }
  }

// 開催期間を過ぎているかどうか
let OverCheck = function(date){
    
  let today = new Date()
  let kaisai_date = Shichou_kikan_Setting(date)
  /*
  let shicho_date = new Date(shicho_day)
  shicho_date = shicho_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
  shicho_date = new Date(shicho_date);*/

  // 今日の日付が開催期間より前ならtrue
  if (kaisai_date > today) {
    return true
  } else {
    return false
  }
}


 //〆切日を整える
 let Shichou_kikan_Setting = function(changedate){
    let date = Date.parse(changedate);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
      set_date.setHours(23, 59, 59);//23時59分59秒に設定

    //return date;
    return set_date
 }

const codeshow = (proc, pg_id, user_id) => {
  emit('call',{cmd:'mypage_scroll_position'});
  emit('call', { cmd:'showcode',proc:proc,pg_id:pg_id,user_id:user_id})
}

let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/HOME-165c0be34f8f806ea21ed5c10d5a46e4"
    window.open(url,"_blank")
}

// Q&Aを開く
const qanda_open = () =>{

  let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
  window.open(url,"_blank")
}        

// ？マークをタップしたときのウィンドウ（スマホのみ）
let q_open = function(text){
    message.value = text
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "q_open";
    contentMessage.value = MessageModal

}
// ユーザー切替え画面の表示
const multipleusers_change = () =>{
    emit('call', { cmd:'multipleprofile_switch',id:GlobalData.user_id})
}

</script>
<style scoped>
.ichiran_button{
  background-color: red;
  color: white;
}

.taiken_table{
  cursor:pointer;
}
.taiken_table:hover{
  
  background-color:royalblue;
}

#moushikomi_list{
  width: 100%;
  border:1px;
  margin-bottom:10px;
}

/* 1列目（種類）のスタイル */
#moushikomi_list tr td:nth-of-type(1){
  width:15%;
  text-align: center;
}
/* 2列目（名称）のスタイル */
#moushikomi_list tr td:nth-of-type(2){
  width:60%;
  text-align: left;
}
/* 3列目（次回参加日）のスタイル */
#moushikomi_list tr td:nth-of-type(3){
  width:25%;
  text-align: center;
}

#moushikomi_list th {
    background-color: orange;  /* 背景色指定 */
  text-align: center;
}

@media screen and (min-width: 961px) {

/* PC版 */

  .floating_over,.sp_button_area{
      display: none
  }
}
@media screen and (max-width: 960px) {

  /* スマホ版 */

  .floating_over{
      display: flex
  }
  .sp_button_area{
    display:block;
  }
}
</style>
